import { toast } from "react-toastify";
import { DropdownActions, DropdownItem } from "../../commons/DropdownActions";
import type { Course } from "../../../services/webServices/course/types";
import { patchCourse } from "../../../services/webServices/course/patch";

type Props = {
  course: Course;
  onActionSuccessed: () => void;
};

export default function CourseAction({ course, onActionSuccessed }: Props) {

  const updateCourseStatus = async (status: number): Promise<boolean> => {
    if (course.publish_status === status) {
      toast.info("وضعیت همین الان هم همین است");
      return false;
    }

    try {
      const success = await patchCourse({
        slugOrId: course.id,
        body: { publish_status: status }
      });

      if (!success) return false;

      toast.success("تغییر وضعیت با موفقیت انجام شد");
      onActionSuccessed();
      return true;
    } catch {
      return false;
    }
  };

  const actions: DropdownItem[] = [
    {
      key: "draft",
      tone: "error",
      label: "پیش نویس",
      action: () => updateCourseStatus(1),
    },
    {
      key: "publishing_soon_approval",
      tone: "secondary",
      label: "در انتظار تایید(بزودی)",
      action: () => updateCourseStatus(2),
    },
    {
      key: "publishing_soon",
      tone: "warning",
      label: "بزودی",
      action: () => updateCourseStatus(3),
    },
    {
      key: "published_approval",
      tone: "info",
      label: "در انتظار تایید",
      action: () => updateCourseStatus(4),
    },
    {
      key: "published",
      tone: "success",
      label: "منتشر شده",
      action: () => updateCourseStatus(5),
    },
  ];

  return (
    <DropdownActions
      items={actions}
      initialKey={actions[course.publish_status - 1]?.key}
    />
  );
};